import { t } from 'i18next';
import {
  CollectorChannelType,
  DateTimeOptions,
  WorkFlowActionTypes,
  WorkflowActionDelayTypes,
  WorkflowAuthenticationTypes,
  WorkflowConditionOperators,
  WorkflowConditionOptions,
  WorkflowEventTypes,
  WorkflowTypeOptions,
} from 'shared/types';
import {
  WorkFlowConditionOptionType,
  WorkFlowConditionVariableTypeOptionType,
  WorkflowFilterOptionTypes,
} from './types';

export const NUMBER_OF_ALLOWED_WORKFLOWS = 30;
export const NUMBER_OF_ALLOWED_ACTIONS = 10;
export const NUMBER_OF_ALLOWED_CONDITIONS = 10;
export const NUMBER_OF_ALLOWED_CONDITIONGROUPS = 5;
export const NUMBER_OF_ALLOWED_CUSTOM_HEADERS = 10;
export const NUMBER_OF_ALLOWED_CONTACT_FIELDS = 10;
export const NUMBER_OF_ALLOWED_ADD_TAGS = 10;
export const NUMBER_OF_ALLOWED_RECIPIENT = 10;

export const WorkFlowTypeOptions: Record<WorkflowTypeOptions, string> = {
  AUTOMATIC: 'workflow.types.automatic',
  MANUAL: 'workflow.types.manual',
};

export const RANK_ORDER_OPTION_POSITION = [
  {
    id: '1',
    value: 'workflow.condition.choice.position_ordinal_one',
  },
  {
    id: '2',
    value: 'workflow.condition.choice.position_ordinal_two',
  },
  {
    id: '3',
    value: 'workflow.condition.choice.position_ordinal_three',
  },
  {
    id: '4',
    value: 'workflow.condition.choice.position_ordinal_four',
  },
  {
    id: '5',
    value: 'workflow.condition.choice.position_ordinal_five',
  },
  {
    id: '6',
    value: 'workflow.condition.choice.position_ordinal_six',
  },
  {
    id: '7',
    value: 'workflow.condition.choice.position_ordinal_seven',
  },
  {
    id: '8',
    value: 'workflow.condition.choice.position_ordinal_eight',
  },
  {
    id: '9',
    value: 'workflow.condition.choice.position_ordinal_nine',
  },
  {
    id: '10',
    value: 'workflow.condition.choice.position_ordinal_ten',
  },
];

export const DATE_TIME_OPTIONS: DateTimeOptions[] = [
  {
    id: 'MMM DD, YYYY',
    format: 'MMM dd, yyyy',
    label: 'builder.settings_panel.date_dropdown_options.format1',
    type: 'DATE',
  },
  {
    id: 'DD-MM-YYYY',
    format: 'dd-MM-yyyy',
    label: 'builder.settings_panel.date_dropdown_options.format2',
    type: 'DATE',
  },
  {
    id: 'YYYY-MM-DD',
    format: 'yyyy-MM-dd',
    label: 'builder.settings_panel.date_dropdown_options.format3',
    type: 'DATE',
  },
  {
    id: 'MM-DD-YYYY',
    format: 'MM-dd-yyyy',
    label: 'builder.settings_panel.date_dropdown_options.format4',
    type: 'DATE',
  },
  {
    id: 'DD-MMM-YYYY',
    format: 'dd-MMM-yyyy',
    label: 'builder.settings_panel.date_dropdown_options.format5',
    type: 'DATE',
  },
  {
    id: 'MMMM DD, YYYY',
    format: 'MMMM dd, yyyy',
    label: 'builder.settings_panel.date_dropdown_options.format6',
    type: 'DATE',
  },
  {
    id: 'YYYY MMM DD',
    format: 'yyyy MMM dd',
    label: 'builder.settings_panel.date_dropdown_options.format7',
    type: 'DATE',
  },
  {
    id: 'MM/DD/YYYY',
    format: 'MM/dd/yyyy',
    label: 'builder.settings_panel.date_dropdown_options.format8',
    type: 'DATE',
  },
  {
    id: 'DD/MM/YYYY',
    format: 'dd/MM/yyyy',
    label: 'builder.settings_panel.date_dropdown_options.format9',
    type: 'DATE',
  },
  {
    id: 'MMM DD, YYYY HH:mm',
    format: 'MMM dd, yyyy HH:mm',
    AmPmFormat: 'MMM DD, YYYY hh:mm A',
    label: 'builder.settings_panel.date_time_dropdown_options.format1',
    type: 'DATE_TIME',
  },
  {
    id: 'DD-MM-YYYY HH:mm',
    format: 'dd-MM-yyyy HH:mm',
    AmPmFormat: 'MMM DD, YYYY hh:mm A',
    label: 'builder.settings_panel.date_time_dropdown_options.format2',
    type: 'DATE_TIME',
  },
  {
    id: 'YYYY-MM-DD HH:mm',
    format: 'yyyy-MM-dd HH:mm',
    AmPmFormat: 'YYYY-MM-DD hh:mm A',
    label: 'builder.settings_panel.date_time_dropdown_options.format3',
    type: 'DATE_TIME',
  },
  {
    id: 'MM-DD-YYYY HH:mm',
    format: 'MM-dd-yyyy HH:mm',
    AmPmFormat: 'MM-DD-YYYY hh:mm A',
    label: 'builder.settings_panel.date_time_dropdown_options.format4',
    type: 'DATE_TIME',
  },
  {
    id: 'DD-MMM-YYYY HH:mm',
    format: 'dd-MMM-yyyy HH:mm',
    AmPmFormat: 'DD-MMM-YYYY hh:mm A',
    label: 'builder.settings_panel.date_time_dropdown_options.format5',
    type: 'DATE_TIME',
  },
  {
    id: 'MMMM DD, YYYY HH:mm',
    format: 'MMMM dd, yyyy HH:mm',
    AmPmFormat: 'MMM DD, YYYY hh:mm A',
    label: 'builder.settings_panel.date_time_dropdown_options.format6',
    type: 'DATE_TIME',
  },
  {
    id: 'YYYY MMM DD HH:mm',
    format: 'yyyy MMM dd HH:mm',
    AmPmFormat: 'YYYY MMM DD hh:mm A',
    label: 'builder.settings_panel.date_time_dropdown_options.format7',
    type: 'DATE_TIME',
  },
  {
    id: 'MM/DD/YYYY HH:mm',
    format: 'MM/dd/yyyy HH:mm',
    AmPmFormat: 'MM/DD/YYYY hh:mm A',
    label: 'builder.settings_panel.date_time_dropdown_options.format8',
    type: 'DATE_TIME',
  },
  {
    id: 'DD/MM/YYYY HH:mm',
    format: 'dd/MM/yyyy HH:mm',
    AmPmFormat: 'DD/MM/YYYY hh:mm A',
    label: 'builder.settings_panel.date_time_dropdown_options.format9',
    type: 'DATE_TIME',
  },
];

export const WorkFlowEventOptions: Record<WorkflowEventTypes, string> = {
  EVERYTIME_A_SURVEY_IS_RESPONDED: 'workflow.event.events.survey',
  EVERYTIME_A_CONTACT_IS_UNSUBSCRIBED: 'workflow.event.events.contact',
  EVERYTIME_A_SPECIFIC_SURVEY_IS_RESPONDED:
    'workflow.event.events.specific_survey',
};

export const WorkFlowMatchOptions: Record<WorkflowConditionOptions, string> = {
  AND: 'workflow.condition.toggle.all',
  OR: 'workflow.condition.toggle.any',
};

export const WorkFlowConditionOperators: Record<
  WorkflowConditionOperators,
  string
> = {
  IS: 'filter_operations.is',
  IS_NOT: 'filter_operations.is_not',
  CONTAINS: 'filter_operations.contains',
  DOES_NOT_CONTAINS: 'filter_operations.does_not_contain',
  STARTS_WITH: 'filter_operations.starts_with',
  ENDS_WITH: 'filter_operations.ends_with',
  IS_EMPTY: 'filter_operations.is_empty',
  IS_NOT_EMPTY: 'filter_operations.is_not_empty',
  GREATER_THAN: 'filter_operations.greater_than',
  LESSER_THAN: 'filter_operations.less_than',
  GREATER_THAN_OR_EQUALS: 'filter_operations.greater_than_or_equals',
  LESSER_THAN_OR_EQUALS: 'filter_operations.less_than_or_equals',
  BETWEEN: 'filter_operations.between',
  BEFORE: 'filter_operations.before',
  AFTER: 'filter_operations.after',
};

const getScaleValues = (event?: WorkflowEventTypes) => [
  {
    id: '0',
    label:
      event === 'EVERYTIME_A_SPECIFIC_SURVEY_IS_RESPONDED'
        ? '0'
        : `0 / ${t('no')}`,
  },
  {
    id: '1',
    label:
      event === 'EVERYTIME_A_SPECIFIC_SURVEY_IS_RESPONDED'
        ? '1'
        : `1 / ${t('yes')}`,
  },
  { id: '2', label: '2' },
  { id: '3', label: '3' },
  { id: '4', label: '4' },
  { id: '5', label: '5' },
  { id: '6', label: '6' },
  { id: '7', label: '7' },
  { id: '8', label: '8' },
  { id: '9', label: '9' },
  { id: '10', label: '10' },
];

export const WorkFlowConditionOptions: WorkFlowConditionOptionType[] = [
  {
    id: 'NPS_RATING',
    groupId: 'NPS',
    label: 'workflow.condition.condition_variable.nps_rating',
    conditionOperators: [
      'IS',
      'IS_NOT',
      'IS_EMPTY',
      'IS_NOT_EMPTY',
      'GREATER_THAN',
      'LESSER_THAN',
      'GREATER_THAN_OR_EQUALS',
      'LESSER_THAN_OR_EQUALS',
    ],
    operatorValueMap: {
      IS: 'DROPDOWN',
      IS_NOT: 'DROPDOWN',
      IS_EMPTY: 'NONE',
      IS_NOT_EMPTY: 'NONE',
      GREATER_THAN: 'DROPDOWN',
      LESSER_THAN: 'DROPDOWN',
      GREATER_THAN_OR_EQUALS: 'DROPDOWN',
      LESSER_THAN_OR_EQUALS: 'DROPDOWN',
    },
    conditionValues: getScaleValues,
  },
  {
    id: 'CSAT_RATING',
    groupId: 'CSAT',
    label: 'workflow.condition.condition_variable.csat_rating',
    conditionOperators: [
      'IS',
      'IS_NOT',
      'IS_EMPTY',
      'IS_NOT_EMPTY',
      'GREATER_THAN',
      'LESSER_THAN',
      'GREATER_THAN_OR_EQUALS',
      'LESSER_THAN_OR_EQUALS',
    ],
    operatorValueMap: {
      IS: 'DROPDOWN',
      IS_NOT: 'DROPDOWN',
      IS_EMPTY: 'NONE',
      IS_NOT_EMPTY: 'NONE',
      GREATER_THAN: 'DROPDOWN',
      LESSER_THAN: 'DROPDOWN',
      GREATER_THAN_OR_EQUALS: 'DROPDOWN',
      LESSER_THAN_OR_EQUALS: 'DROPDOWN',
    },
    conditionValues: getScaleValues,
  },
  {
    id: 'CES_RATING',
    groupId: 'CES',
    label: 'workflow.condition.condition_variable.ces_rating',
    conditionOperators: [
      'IS',
      'IS_NOT',
      'IS_EMPTY',
      'IS_NOT_EMPTY',
      'GREATER_THAN',
      'LESSER_THAN',
      'GREATER_THAN_OR_EQUALS',
      'LESSER_THAN_OR_EQUALS',
    ],
    operatorValueMap: {
      IS: 'DROPDOWN',
      IS_NOT: 'DROPDOWN',
      IS_EMPTY: 'NONE',
      IS_NOT_EMPTY: 'NONE',
      GREATER_THAN: 'DROPDOWN',
      LESSER_THAN: 'DROPDOWN',
      GREATER_THAN_OR_EQUALS: 'DROPDOWN',
      LESSER_THAN_OR_EQUALS: 'DROPDOWN',
    },
    conditionValues: getScaleValues,
  },
  {
    id: 'NPS_RATING_GROUP',
    groupId: 'NPS',
    label: 'workflow.condition.condition_variable.nps_rating_group',
    conditionOperators: ['IS', 'IS_NOT', 'IS_EMPTY', 'IS_NOT_EMPTY'],
    operatorValueMap: {
      IS: 'DROPDOWN',
      IS_NOT: 'DROPDOWN',
      IS_EMPTY: 'NONE',
      IS_NOT_EMPTY: 'NONE',
    },
    conditionValues: () => [
      { id: 'PROMOTER', label: 'Promoter' },
      { id: 'PASSIVE', label: 'Passive' },
      { id: 'DETRACTOR', label: 'Detractor' },
    ],
  },
  {
    id: 'CSAT_RATING_GROUP',
    groupId: 'CSAT',
    label: 'workflow.condition.condition_variable.csat_rating_group',
    conditionOperators: ['IS', 'IS_NOT', 'IS_EMPTY', 'IS_NOT_EMPTY'],
    operatorValueMap: {
      IS: 'DROPDOWN',
      IS_NOT: 'DROPDOWN',
      IS_EMPTY: 'NONE',
      IS_NOT_EMPTY: 'NONE',
    },
    conditionValues: () => [
      { id: 'POSITIVE', label: 'Positive' },
      { id: 'NEUTRAL', label: 'Neutral' },
      { id: 'NEGATIVE', label: 'Negative' },
    ],
  },
  {
    id: 'CES_RATING_GROUP',
    groupId: 'CES',
    label: 'workflow.condition.condition_variable.ces_rating_group',
    conditionOperators: ['IS', 'IS_NOT', 'IS_EMPTY', 'IS_NOT_EMPTY'],
    operatorValueMap: {
      IS: 'DROPDOWN',
      IS_NOT: 'DROPDOWN',
      IS_EMPTY: 'NONE',
      IS_NOT_EMPTY: 'NONE',
    },
    conditionValues: () => [
      { id: 'POSITIVE', label: 'Positive' },
      { id: 'NEUTRAL', label: 'Neutral' },
      { id: 'NEGATIVE', label: 'Negative' },
    ],
  },
  {
    id: 'PREVIOUS_NPS_RATING',
    groupId: 'NPS',
    label: 'workflow.condition.condition_variable.previous_nps_rating',
    conditionOperators: [
      'IS',
      'IS_NOT',
      'IS_EMPTY',
      'IS_NOT_EMPTY',
      'GREATER_THAN',
      'LESSER_THAN',
      'GREATER_THAN_OR_EQUALS',
      'LESSER_THAN_OR_EQUALS',
    ],
    operatorValueMap: {
      IS: 'DROPDOWN',
      IS_NOT: 'DROPDOWN',
      IS_EMPTY: 'NONE',
      IS_NOT_EMPTY: 'NONE',
      GREATER_THAN: 'DROPDOWN',
      LESSER_THAN: 'DROPDOWN',
      GREATER_THAN_OR_EQUALS: 'DROPDOWN',
      LESSER_THAN_OR_EQUALS: 'DROPDOWN',
    },
    conditionValues: getScaleValues,
  },
  {
    id: 'PREVIOUS_CSAT_RATING',
    groupId: 'CSAT',
    label: 'workflow.condition.condition_variable.previous_csat_rating',
    conditionOperators: [
      'IS',
      'IS_NOT',
      'IS_EMPTY',
      'IS_NOT_EMPTY',
      'GREATER_THAN',
      'LESSER_THAN',
      'GREATER_THAN_OR_EQUALS',
      'LESSER_THAN_OR_EQUALS',
    ],
    operatorValueMap: {
      IS: 'DROPDOWN',
      IS_NOT: 'DROPDOWN',
      IS_EMPTY: 'NONE',
      IS_NOT_EMPTY: 'NONE',
      GREATER_THAN: 'DROPDOWN',
      LESSER_THAN: 'DROPDOWN',
      GREATER_THAN_OR_EQUALS: 'DROPDOWN',
      LESSER_THAN_OR_EQUALS: 'DROPDOWN',
    },
    conditionValues: getScaleValues,
  },
  {
    id: 'PREVIOUS_CES_RATING',
    groupId: 'CES',
    label: 'workflow.condition.condition_variable.previous_ces_rating',
    conditionOperators: [
      'IS',
      'IS_NOT',
      'IS_EMPTY',
      'IS_NOT_EMPTY',
      'GREATER_THAN',
      'LESSER_THAN',
      'GREATER_THAN_OR_EQUALS',
      'LESSER_THAN_OR_EQUALS',
    ],
    operatorValueMap: {
      IS: 'DROPDOWN',
      IS_NOT: 'DROPDOWN',
      IS_EMPTY: 'NONE',
      IS_NOT_EMPTY: 'NONE',
      GREATER_THAN: 'DROPDOWN',
      LESSER_THAN: 'DROPDOWN',
      GREATER_THAN_OR_EQUALS: 'DROPDOWN',
      LESSER_THAN_OR_EQUALS: 'DROPDOWN',
    },
    conditionValues: getScaleValues,
  },
  {
    id: 'PREVIOUS_NPS_RATING_GROUP',
    groupId: 'NPS',
    label: 'workflow.condition.condition_variable.previous_nps_rating_group',
    conditionOperators: ['IS', 'IS_NOT', 'IS_EMPTY', 'IS_NOT_EMPTY'],
    operatorValueMap: {
      IS: 'DROPDOWN',
      IS_NOT: 'DROPDOWN',
      IS_EMPTY: 'NONE',
      IS_NOT_EMPTY: 'NONE',
    },
    conditionValues: () => [
      { id: 'PROMOTER', label: 'Promoter' },
      { id: 'PASSIVE', label: 'Passive' },
      { id: 'DETRACTOR', label: 'Detractor' },
    ],
  },
  {
    id: 'PREVIOUS_CSAT_RATING_GROUP',
    groupId: 'CSAT',
    label: 'workflow.condition.condition_variable.previous_csat_rating_group',
    conditionOperators: ['IS', 'IS_NOT', 'IS_EMPTY', 'IS_NOT_EMPTY'],
    operatorValueMap: {
      IS: 'DROPDOWN',
      IS_NOT: 'DROPDOWN',
      IS_EMPTY: 'NONE',
      IS_NOT_EMPTY: 'NONE',
    },
    conditionValues: () => [
      { id: 'POSITIVE', label: 'Positive' },
      { id: 'NEUTRAL', label: 'Neutral' },
      { id: 'NEGATIVE', label: 'Negative' },
    ],
  },
  {
    id: 'PREVIOUS_CES_RATING_GROUP',
    groupId: 'CES',
    label: 'workflow.condition.condition_variable.previous_ces_rating_group',
    conditionOperators: ['IS', 'IS_NOT', 'IS_EMPTY', 'IS_NOT_EMPTY'],
    operatorValueMap: {
      IS: 'DROPDOWN',
      IS_NOT: 'DROPDOWN',
      IS_EMPTY: 'NONE',
      IS_NOT_EMPTY: 'NONE',
    },
    conditionValues: () => [
      { id: 'POSITIVE', label: 'Positive' },
      { id: 'NEUTRAL', label: 'Neutral' },
      { id: 'NEGATIVE', label: 'Negative' },
    ],
  },
  {
    id: 'SURVEY_ID',
    label: 'workflow.condition.condition_variable.survey_name',
    conditionOperators: ['IS', 'IS_NOT'],
    operatorValueMap: {
      IS: 'DROPDOWN',
      IS_NOT: 'DROPDOWN',
    },
  },
  {
    id: 'CHANNEL',
    label: 'workflow.condition.condition_variable.channel',
    conditionOperators: ['IS', 'IS_NOT'],
    operatorValueMap: {
      IS: 'DROPDOWN',
      IS_NOT: 'DROPDOWN',
    },
    conditionValues: () =>
      [
        { id: 'EMAIL', label: 'channel.email' },
        { id: 'WEB_APP', label: 'channel.web_app' },
        {
          id: 'EMAIL_EMBED',
          label: 'channel.email_embed',
        },
        {
          id: 'WEB_LINK',
          label: 'channel.shareable_link',
        },
      ] as { id: CollectorChannelType; label: string }[],
  },
  {
    id: 'SEGMENT',
    label: 'workflow.condition.condition_variable.segment',
    conditionOperators: [
      'IS',
      'IS_NOT',
      'CONTAINS',
      'DOES_NOT_CONTAINS',
      'STARTS_WITH',
      'ENDS_WITH',
    ],
    operatorValueMap: {
      IS: 'DROPDOWN',
      IS_NOT: 'DROPDOWN',
      CONTAINS: 'TEXT',
      DOES_NOT_CONTAINS: 'TEXT',
      // CONTAINS: 'MULTI_SELECT',
      // DOES_NOT_CONTAINS: 'MULTI_SELECT',
      STARTS_WITH: 'TEXT',
      ENDS_WITH: 'TEXT',
    },
  },
  {
    id: 'LIST',
    label: 'workflow.condition.condition_variable.list',
    conditionOperators: [
      'IS',
      'IS_NOT',
      'CONTAINS',
      'DOES_NOT_CONTAINS',
      'STARTS_WITH',
      'ENDS_WITH',
    ],
    operatorValueMap: {
      IS: 'DROPDOWN',
      IS_NOT: 'DROPDOWN',
      CONTAINS: 'TEXT',
      DOES_NOT_CONTAINS: 'TEXT',
      // CONTAINS: 'MULTI_SELECT',
      // DOES_NOT_CONTAINS: 'MULTI_SELECT',
      STARTS_WITH: 'TEXT',
      ENDS_WITH: 'TEXT',
    },
  },
  {
    id: 'QUESTION',
    label: 'workflow.condition.condition_variable.question',
  },
  {
    id: 'CONTACT_FIELD',
    label: 'workflow.condition.condition_variable.contact_field',
  },
];

export const WorkFlowConditionVariableTypeOptions: WorkFlowConditionVariableTypeOptionType[] =
  [
    {
      id: 'RATING',
      label: 'responses.filter_condition.response_fields.rating',
    },
    {
      id: 'RATING_GROUP',
      label: 'responses.filter_condition.response_fields.rating_group',
    },
  ];

export const DateTimeConditionValue = [
  { id: 'Today', label: 'filter_operations.today' },
  {
    id: 'Yesterday',
    label: 'filter_operations.yesterday',
  },
  {
    id: 'Last 7 days',
    label: 'filter_operations.Last_7_days',
  },
  {
    id: 'Last 30 days',
    label: 'filter_operations.Last_30_days',
  },
  {
    id: 'Next 7 days',
    label: 'filter_operations.next_7_days',
  },
  {
    id: 'Next 30 days',
    label: 'filter_operations.next_30_days',
  },
];

export const WorkFlowActionOptions: Record<WorkFlowActionTypes, string> = {
  SEND_AN_EMAIL: 'workflow.action.action_type.send_an_email',
  SEND_AN_EMAIL_TO_RESPONDENT: 'workflow.action.action_type.to_respondent',
  WEBHOOK: 'workflow.action.action_type.webhook',
  MARK_AS_FAVOURITE: 'workflow.action.action_type.mark_as_favorite',
  MARK_AS_INVALID: 'workflow.action.action_type.mark_as_invalid',
  'MARK_AS_NON-ACTIONABLE': 'workflow.action.action_type.non_actionable',
  UPDATE_A_CONTACT: 'workflow.action.action_type.update_a_contact',
  ADD_TAGS: 'workflow.action.action_type.add_tags',
};

export const WorkFlowAuthOptions: Record<WorkflowAuthenticationTypes, string> =
  {
    api_key: 'forms.labels.API_key',
    basic_auth: 'workflow.action.webhook_auth.basic_auth',
    None: 'workflow.action.webhook_auth.none',
  };

export const WorkFlowDelayTypeOptions: Record<
  WorkflowActionDelayTypes,
  string
> = {
  Minutes: 'workflow.action.delay_type.minutes',
  Hours: 'workflow.action.delay_type.hours',
  Days: 'workflow.action.delay_type.days',
};

export const WorkflowFilterOptions: Record<WorkflowFilterOptionTypes, string> =
  {
    ALL: 'workflow.condition.toggle.all',
    ACTIVE: 'contacts.import_contact.form_choices.contact_status.ACTIVE',
    INACTIVE: 'contacts.import_contact.form_choices.contact_status.IN_ACTIVE',
  };

export const SEARCHABLE_FIELDS_WFLOW_UPDATE_CONTACT = ['timezone', 'language'];
